import {
    saveEncodedValueToSessionStorage,
    getDecodedValueFromSessionStorage,
} from 'root/utils/dom/sessionStorage';

export const sessionStartTimeKey = 'session_start_time';
export const sessionScrolledKey = 'scrolled_75';
export default function sessionTracking() {
    setSessionStartTime(sessionStartTimeKey);
    setSessionScrolled(sessionScrolledKey);
}

const setSessionStartTime = (sessionStartTimeKey: string) => {
    const timestampMilliseconds = new Date().getTime();
    if (!getDecodedValueFromSessionStorage(sessionStartTimeKey)) {
        saveEncodedValueToSessionStorage(
            sessionStartTimeKey,
            timestampMilliseconds.toString()
        );
    }
};
const setSessionScrolled = (sessionScrolledKey: string) => {
    window.onscroll = function () {
        const scrollableHeight =
            document.documentElement.scrollHeight - window.innerHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const scrollPercentage = (scrollTop / scrollableHeight) * 100;
        const isScrolled75 = scrollPercentage >= 75;

        if (isScrolled75) {
            if (!getDecodedValueFromSessionStorage(sessionScrolledKey)) {
                saveEncodedValueToSessionStorage(
                    sessionScrolledKey,
                    isScrolled75.toString()
                );
            }
            window.onscroll = null;
        }
    };
};
